//export interface MobileBaseObject {
//}

export class MobileBaseObject { 
  public id?: string;
  public version?: number[];
  public createdAt?: Date;
  public updatedAt?: Date;
  public deleted?: boolean;

  public constructor(
    //public id: string,
    //public version: number[],
    //public createdAt: Date,
    //public updatedAt: Date,
    //public deleted: boolean,
  ) {}

}
